import React, {Component} from "react";
import {withStyles} from "@material-ui/core/styles";
import TechnicalService from "../TechnicalService";
import SignInContainer from "../../redux/containers/AuthContainer";
import SignUp from "../../redux/containers/SignupContainer";
import Transaction from "../../redux/containers/TransactionContainer";
import Account from "../../redux/containers/MerchantContainer";
import Products from "../../Components/Products";
import Admin from "../../redux/containers/AdminContainer";
import Redmo from "../../Components/Redmo";
import NoMatch from "../404";
import {Route, Switch, Redirect} from "react-router-dom";
import Ability from "../../config/Ability";

//import {Header, Footer} from "../Layouts";

const styles = theme => ({
    // Routecontent: {
    //     flexGrow: 1,
    //     padding: theme.spacing.unit * 2,
    //     height: '85vh',
    //     overflow: 'auto',
    // },
});

class LandPage extends Component {

    render() {
        const {isAuthenticated} = this.props;
        const isAdmin = Ability.can("view","/admin");
        //console.log(process.env);
        //console.log("admin",isAdmin);
        //console.debug("landPage",this.props);

        function PrivateRoute({component: Component, ...rest}) {
            return (
                <Route
                    {...rest}
                    render={props =>
                        isAuthenticated ? (
                            <Component {...props} />
                        ) : (
                            <Redirect
                                to={{
                                    pathname: "/",
                                    state: {from: props.location}
                                }}
                            />
                        )
                    }
                />
            );
        }

        function AdminRoute({component: Component, ...rest}) {
            return(
                <Route
                    {...rest}
                    render={props =>
                        isAuthenticated && isAdmin ? (
                            <Component {...props} />
                        ) : (
                            <Redirect
                                to={{
                                    pathname: "/",
                                    state: {from: props.location}
                                }}
                            />
                        )
                    }
                />
            );
        }

        return (
            <div>
                <Switch>
                    <Route path="/" exact component={SignInContainer}/>
                    <Route path="/signup" component={SignUp}/>
                    <AdminRoute path="/admin" component={Admin}/>
                    <PrivateRoute path="/transaction" component={Transaction}/>
                    <PrivateRoute path="/technicalService" component={TechnicalService}/>
                    <PrivateRoute path="/account" component={Account}/>
                    <PrivateRoute path="/products" component={Products}/>
                    <PrivateRoute path="/redmo" component={Redmo}/>
                    <Route component={NoMatch}/>
                </Switch>
            </div>
        );
    }
}

export default withStyles(styles)(LandPage);